module.exports = __webpack_public_path__ + "static/media/ertrz.77927dc3.jpg";